
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('[data-copco-size-live]');
    if (!wrapper) return;

    const outerEl = wrapper.querySelector('[data-size-outer]');
    const innerEl = wrapper.querySelector('[data-size-inner]');
    const heightEl = wrapper.querySelector('[data-size-height]');

const sizeData = {
  '50x43': {
    outer: '50 × 43 cm',
    inner: '40 × 30 cm',
    height: '22 cm'
  },
   '60x55': {
    outer: '60 × 55 cm',
    inner: '36 × 30 cm',
    height: '16 cm'
  },
  '70x55': {
    outer: '70 × 55 cm',
    inner: '46 × 30 cm',
    height: '18 cm'
  },
  '80x60': {
    outer: '80 × 60 cm',
    inner: '56 × 40 cm',
    height: '20 cm'
  },
  '90x70': {
    outer: '90 × 70 cm',
    inner: '64 × 47 cm',
    height: '23 cm'
  },
  '100x80': {
    outer: '100 × 80 cm',
    inner: '73 × 54 cm',
    height: '25 cm'
  },
  '110x90': {
    outer: '110 × 90 cm',
    inner: '87 × 69 cm',
    height: '27 cm'
  },
  '125x100': {
    outer: '125 × 100 cm',
    inner: '97 × 87 cm',
    height: '30 cm'
  },
   '125x90': {
    outer: '125 × 90 cm',
    inner: '97 × 77 cm',
    height: '30 cm'
  }
};

function normalizeSize(text) {
  const cleanText = String(text || '')
    .toLowerCase()
    .replace(/×/g, 'x');

  const match = cleanText.match(/(\d+)\s*x\s*(\d+)/);

  if (!match) return '';

  return match[1] + 'x' + match[2];
}

    function getSelectedVariantText() {
      const checkedInput =
        document.querySelector('input[name*="Größe"]:checked') ||
        document.querySelector('input[name*="Size"]:checked') ||
        document.querySelector('input[type="radio"]:checked');

      if (!checkedInput) return '';

      const labelText =
        checkedInput.closest('label')?.innerText ||
        document.querySelector(`label[for="${checkedInput.id}"]`)?.innerText ||
        '';

      return (
        checkedInput.getAttribute('aria-label') ||
        checkedInput.value ||
        checkedInput.defaultValue ||
        labelText ||
        ''
      );
    }

    function updateSizeInfo() {
      const selectedText = getSelectedVariantText();
      const selectedKey = normalizeSize(selectedText);
      const data = sizeData[selectedKey];

      console.log('selectedText:', selectedText);
      console.log('selectedKey:', selectedKey);
      console.log('mapped data:', data);

      if (!data) return;

      if (outerEl) outerEl.textContent = data.outer;
      if (innerEl) innerEl.textContent = data.inner;
      if (heightEl) heightEl.textContent = data.height;
    }

    document.addEventListener('change', () => {
      setTimeout(updateSizeInfo, 80);
    });

    document.addEventListener('click', () => {
      setTimeout(updateSizeInfo, 80);
    });

    updateSizeInfo();
  });
